import React from "react";
import Hero from "../components/Hero";
import MemorableMoments from "../components/MemorableMoments";

export default function PhotosPage() {
  return (
    <div className="bg-[#1A1F2B] text-white w-full min-h-screen flex flex-col items-center">

      {/* Section 1: Hero */}
      {/* <section className="w-full bg-[#1A1F2B] px-6 py-16 text-center mt-8" data-aos="fade-up">
        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-[#D9A05B]">
          Church Gallery
        </h1>
        <p className="text-lg md:text-xl max-w-3xl mx-auto text-[#F5E9D8]">
          A glimpse into the worship, fellowship, and joyful moments at Moriah Church.
          These photos reflect our faith, unity, and growing community.
        </p>
      </section> */}
      <Hero title="Church Gallery" description="A glimpse into the worship, fellowship, and joyful moments at Moriah Church.  These photos reflect our faith, unity, and growing community."/>

      {/* Section 2: Photo Grid */}
      {/* <section className="w-full bg-[#F5E9D8] text-[#1A1F2B] px-6 py-14 rounded-t-3xl" data-aos="fade-up">
        <h2 className="text-3xl font-bold text-center mb-10">Memorable Moments</h2>
        <p className="text-lg text-center max-w-3xl mx-auto mb-10">
          Experience the heart of Moriah Church through worship services, fellowship,
          prayers, and community gatherings that bring people closer to God.
        </p>
         
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-aos="fade-up">
          <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/memo1.jpg" alt="Church worship moment" />
          <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/memo2.jpg" alt="Prayer gathering at church" />
          <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/memo3.jpg" alt="Sunday service fellowship" />
          <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/memo4.jpg" alt="Church community moment" />
          <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/event1.jpg" alt="Special church event" />
          <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/memo6.jpg" alt="Worship and praise session" />
        </div>
      </section> */}
      <MemorableMoments />

      {/* Section 3: Events Gallery */}
      <section className="w-full bg-[#1A1F2B] px-6 py-14">
        <h2 className="text-3xl font-bold text-center text-[#D9A05B] mb-8" data-aos="fade-up">
          Special Events
        </h2>
        <p className="text-lg text-center max-w-3xl mx-auto text-[#F5E9D8] mb-10" data-aos="fade-up">
          Festivals, outreach programs, prayer meetings, and special celebrations
          captured through meaningful moments.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-aos="fade-up">
          <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/special-evt-one.jpeg" alt="Church festival celebration" />
          <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/special-evt-two.jpeg" alt="Outreach program" />
          <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/special-evt-three.jpeg" alt="Prayer meeting event" />
        </div>
      </section>

      {/* Section 4: Youth & Worship Moments */}
      <section className="w-full bg-[#D2CBC3] text-[#1A1F2B] px-6 py-14 rounded-t-3xl">
        <h2 className="text-3xl font-bold text-center mb-8" data-aos="fade-up">
          Youth & Worship Moments
        </h2>
        <p className="text-lg text-center max-w-3xl mx-auto mb-10" data-aos="fade-up">
          Youth ministry activities, worship team practices, and fellowship moments
          that reflect passion, faith, and spiritual growth.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-6xl mx-auto" data-aos="fade-up">
          <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/youth-meet-12.jpeg" alt="Youth fellowship" />
          <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/youth-meet-2.jpeg" alt="Youth worship team" />
          <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/youth-meet-13.jpeg" alt="Worship praise moment" />
        </div>
      </section>

      {/* Section 5: CTA */}
      <section className="w-full bg-[#F5E9D8] text-[#1A1F2B] px-6 py-14" data-aos="fade-up">
        <div className="max-w-4xl mx-auto text-center space-y-6" >
          <h2 className="text-3xl font-bold">Want to See More?</h2>
          <p className="text-lg leading-relaxed max-w-3xl mx-auto">
            Follow us on social media to explore complete photo albums, videos,
            and live updates from our church events and services.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4">
            <a
              href="https://www.facebook.com/moriahchurchdelhi"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-3 bg-[#D9A05B] text-white font-bold rounded-xl shadow-md hover:bg-[#C9A86A] transition-all duration-300"
            >
              Visit Facebook Page
            </a>

            <a
              href="https://www.instagram.com/moriahchurch.naraina/"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-3 bg-[#D9A05B] text-white font-bold rounded-xl shadow-md hover:bg-[#C9A86A] transition-all duration-300"
            >
              Visit Instagram Page
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
